(() => {
  const fragrances = document.querySelector(
    ".variations.variations--fragrances"
  );
  const track = fragrances.querySelector(".product-form__input-inner");
  const prevButton = document.querySelector(
    ".product-form__header-arrow--left"
  );
  const nextButton = document.querySelector(
    ".product-form__header-arrow--right"
  );

  if (!fragrances || !prevButton || !nextButton) {
    return;
  }

  if (track) {
    if (track.scrollLeft <= 0) {
      prevButton.setAttribute("disabled", "");
    }

    prevButton.addEventListener("click", () => {
      nextButton.removeAttribute("disabled");

      track.scrollTo({
        left: track.scrollLeft - track.firstElementChild.offsetWidth,
        behavior: "smooth",
      });
    });

    nextButton.addEventListener("click", () => {
      prevButton.removeAttribute("disabled");

      track.scrollTo({
        left: track.scrollLeft + track.firstElementChild.offsetWidth,
        behavior: "smooth",
      });
    });

    track.addEventListener("scroll", () => {
      const trackScrollWidth = track.scrollWidth;
      const trackOuterWidth = track.clientWidth;

      prevButton.removeAttribute("disabled");
      nextButton.removeAttribute("disabled");

      if (track.scrollLeft <= 0) {
        prevButton.setAttribute("disabled", "");
      }

      if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
        nextButton.setAttribute("disabled", "");
      }
    });

    fragrances.querySelector('.active a').scrollIntoView({inline: 'start'})
  }

  // Handle fragrance name display on hover/tap
  const fragranceInfo = fragrances.querySelector('.product-form__info p');
  const fragranceLinks = fragrances.querySelectorAll('.product-form__item a');
  
  if (fragranceInfo && fragranceLinks.length > 0) {
    // Store the original product title
    const originalTitle = fragranceInfo.textContent;
    
    fragranceLinks.forEach((link) => {
      // Desktop: hover events
      link.addEventListener('mouseenter', (e) => {
        const fragranceName = e.target.getAttribute('title');
        if (fragranceName) {
          fragranceInfo.textContent = fragranceName;
        }
      });
      
      link.addEventListener('mouseleave', () => {
        fragranceInfo.textContent = originalTitle;
      });
      
      // Mobile: touch events
      link.addEventListener('touchstart', (e) => {
        const fragranceName = e.target.getAttribute('title');
        if (fragranceName) {
          fragranceInfo.textContent = fragranceName;
        }
      });
      
      link.addEventListener('touchend', () => {
        fragranceInfo.textContent = originalTitle;
      });
      
      // Handle touch cancel (e.g., when user scrolls while touching)
      link.addEventListener('touchcancel', () => {
        fragranceInfo.textContent = originalTitle;
      });
    });
  }
})();
